import { FC } from 'react';

import IncentivesMarketAdminPanelConfigurationOfferConditions from './IncentivesMarketAdminPanelConfigurationOfferConditions';
import IncentivesMarketAdminPanelConfigurationSharePurchaseContract from './IncentivesMarketAdminPanelConfigurationSharePurchaseContract';
import IncentivesMarketAdminPanelBeneficiaryAccess from './IncentivesMarketAdminPanelBeneficiaryAccess';
import IncentivesMarketAdminPanelConfigurationMailingList from './IncentivesMarketAdminPanelConfigurationMailingList';

type IncentivesMarketAdminPanelConfigurationProps = {
  societyId: string;
  onToggleBeneficiaryAccess: (beneficiaryIds: string[], enabled: boolean) => void;
  isLoading?: boolean;
};

const IncentivesMarketAdminPanelConfiguration: FC<
  IncentivesMarketAdminPanelConfigurationProps
> = ({ societyId, onToggleBeneficiaryAccess, isLoading = false }) => (
  <>
    <IncentivesMarketAdminPanelConfigurationOfferConditions societyId={societyId} />
    <IncentivesMarketAdminPanelConfigurationSharePurchaseContract
      societyId={societyId}
    />
    <IncentivesMarketAdminPanelBeneficiaryAccess
      societyId={societyId}
      onToggleBeneficiaryAccess={onToggleBeneficiaryAccess}
      isLoading={isLoading}
    />
    <IncentivesMarketAdminPanelConfigurationMailingList societyId={societyId} />
  </>
);

export default IncentivesMarketAdminPanelConfiguration;
